import(/* webpackMode: "eager" */ "/app/app/performers/page.js");
